import * as React from "react";
import styled from "@emotion/styled";

const TERMS_URL = "https://www.teacherspayteachers.com/Terms-of-Service/#4C";

export const AttestationLanguage: React.FC = () => {
  return (
    <Disclaimer>
      By publishing, I agree to the{" "}
      <a target="_blank" href={TERMS_URL}>
        Terms
      </a>{" "}
      and I certify that the material does not infringe on the right of any
      third party.
    </Disclaimer>
  );
};

const Disclaimer = styled.div({
  fontSize: "0.8125rem",
});
